import { getOfficeStatusDetails } from "../../../../actions/Utilities/OfficeStatusDetails";
import { useQuery } from "react-query";

export const useGetOfficeStatusDetails = () => {
  return useQuery("OfficeStatusDetails", getOfficeStatusDetails, {
    refetchOnWindowFocus: false,
  });
};
